import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'
import { FIELDS, SUBSCRIPTIONS, DEFAULT_COLUMNS, COLUMNS_CONFIG } from 'frontend/locations/locations-table-helpers'

export const LocationDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,
  subscriptions: SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}
